import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const featureCardDefaultVariants = {
  "shape": "rectangle"
}
const featureCardCompoundVariants = []

const featureCardSlotNames = [
  [
    "root",
    "FeatureCard__root"
  ],
  [
    "wrapper",
    "FeatureCard__wrapper"
  ],
  [
    "content",
    "FeatureCard__content"
  ],
  [
    "shelf",
    "FeatureCard__shelf"
  ],
  [
    "media",
    "FeatureCard__media"
  ]
]
const featureCardSlotFns = /* @__PURE__ */ featureCardSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, featureCardDefaultVariants, getSlotCompoundVariant(featureCardCompoundVariants, slotName))])

const featureCardFn = memo((props = {}) => {
  return Object.fromEntries(featureCardSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const featureCardVariantKeys = [
  "shape"
]
const getVariantProps = (variants) => ({ ...featureCardDefaultVariants, ...compact(variants) })

export const featureCard = /* @__PURE__ */ Object.assign(featureCardFn, {
  __recipe__: false,
  __name__: 'featureCard',
  raw: (props) => props,
  variantKeys: featureCardVariantKeys,
  variantMap: {
  "shape": [
    "square",
    "rectangle"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, featureCardVariantKeys)
  },
  getVariantProps
})